<template>
  <div class="main">
    <div class="box">
      <!-- 标题 -->
      <div class="title">
        <div class="image">
          <img class="image" :src="logo" alt />
        </div>
        <div class="title">{{title}}</div>
        <div class="more" @click="goMore">
          MORE
          <svg-icon class="svgIcon" icon-class="right"></svg-icon>
        </div>
      </div>

      <!-- 列表 -->
      <div class="list">
        <template v-for="(item, index) in model">
          <div class="card" :key="index" @click="goArticle(item.id,item.link_url)">
            <div class="image">
              <img :src="item.cover?item.cover:'./../../assets/pc/zhuanjia-bg.png'" alt />
              <img v-if="play" class="play" src="./../../assets/pc/play.png" alt />
            </div>
            <div class="card-title">{{item.title}}<img src="../../assets/new.png" alt="" v-if="index==0"  class="newPublic"></div>
            
            <div class="time">{{item.release_time}}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "list-pc",
  props: {
    title: {
      type: String,
      default: ""
    },
    logo: {
      type: String,
      default: ""
    },
    play: {
      type: Boolean,
      default: false
    },
    model: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: false
    }
  },
  data() {
    return {
      logo_image: null
    };
  },
  created() {
    this.logo_image = this.logo;
  },
  methods: {
    goMore() {
      this.$store.dispatch("change_active", this.value);
      this.$router.push({
        path: "/detail",
        query: {
          id: this.value
        }
      });
    },

    goArticle(id,url) {
      this.$store.dispatch("change_active", this.value)
      if(url) {
        // 如果有外链 跳转外链
        window.location.href = url
        return;
      }
      this.$router.push({
        path: "/article",
        query: {
          id
        }
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.main {
  padding-bottom: 30px;
}
.box {
  .title {
    height: 70px;
    width: 1178px;
    background: #f5f5f5;
    border-radius: 10px;
    display: flex;
    line-height: 70px;
    margin-bottom: 20px;

    .image {
      width: 70px;
      position: relative;

      .image {
        width: 32px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .title {
      flex: 1;
      color: #101010;
      font-size: 24px;
      font-weight: 600;
    }

    .more {
      flex: 1;
      font-size: 22px;
      color: #aaa;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .svgIcon {
        font-size: 32px;
      }
    }
  }

  .list {
    padding-left: 15px;
    padding-right: 12px;
    width: 100%;
    box-sizing: border-box;
    // display: flex;
    // justify-content: space-between;
    display: grid;
    grid-template-columns: repeat(3,1fr);
   
    .card:nth-child(3n + 1) {
      justify-self: start;
    }

    .card:nth-child(3n + 2) {
      justify-self: center;
    }

    .card:nth-child(3n) {
      justify-self: end;
    }
    
    .card {
      display: grid;
      width: 346px;
      grid-template-rows: 230px 17px 48px 12px 22px;

      .image {
        grid-row: 1/2;
        position: relative;
        
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }

        .play {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
        }
      }
      .newPublic {
        width: 30px;
        height: 20px;
        vertical-align: middle;     
        // margin-left: 10px;
      }
      .card-title {
        grid-row: 3/4;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(50, 50, 50, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: inline-block;
      }

      .time {
        grid-row: 5/6;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(170, 170, 170, 1);
        opacity: 1;
      }
    }
  }
}
</style>